import { render, staticRenderFns } from "./ProjectChild.vue?vue&type=template&id=299d2843&scoped=true&"
import script from "./ProjectChild.vue?vue&type=script&lang=js&"
export * from "./ProjectChild.vue?vue&type=script&lang=js&"
import style0 from "./ProjectChild.vue?vue&type=style&index=0&id=299d2843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299d2843",
  null
  
)

export default component.exports